import { render } from "./collectStoreItem.vue?vue&type=template&id=1d3c5318"
import script from "./collectStoreItem.vue?vue&type=script&lang=js"
export * from "./collectStoreItem.vue?vue&type=script&lang=js"

import "./collectStoreItem.vue?vue&type=style&index=0&id=1d3c5318&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__